var _desc;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "500 190 285 415",
    xmlSpace: "default",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.4.0")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 640 392.9643125459597)",
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -21.142408349300638 -82.80268860720346)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    points: "20.82499999999999,4.094999999999999 15.86499999999998,-4.094999999999999 -20.825000000000017,-4.094999999999999 -15.865000000000009,4.094999999999999 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -15.811109413958263 -73.98537298026164)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    points: "-16.47,3.094999999999999 20.22,3.094999999999999 16.480000000000018,-3.094999999999999 -20.22,-3.094999999999999 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 11.215312127654954 -17.51277299250421)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(214,28,78)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-262.9, -229.885)",
    d: "M 288.34 288.73 C 296.98999999999995 281.38 303.96 272.13 308.64 261.63 L 253.85 171.04 L 217.16 171.04 L 288.34 288.73 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -67.52253304639771 -91.6243563149088)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    points: "-16.47,3.0999999999999943 20.22,3.0999999999999943 16.47,-3.1000000000000227 -20.22,-3.1000000000000227 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -72.97569024311935 -100.62881141468299)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    points: "20.954999999999984,4.314999999999998 15.734999999999985,-4.314999999999998 -20.955000000000013,-4.314999999999998 -15.735000000000014,4.314999999999998 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -26.582509303731683 -18.8880305137844)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(214,28,78)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-219.475, -228.30499999999998)",
    d: "M 251.58 305.83 C 262.39 304.03 272.43 299.96999999999997 281.2 294.14 L 194.44 150.77999999999997 L 157.75 150.77999999999997 L 251.58 305.83 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -88.43863319599404 -59.366733695514625)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    points: "15.77000000000001,-4.27000000000001 -20.929999999999993,-4.27000000000001 -15.759999999999991,4.269999999999982 20.930000000000007,4.269999999999982 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -83.01594056461727 -50.3970952418488)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    points: "16.480000000000018,-3.094999999999999 -20.22,-3.094999999999999 -16.47,3.094999999999999 20.220000000000027,3.094999999999999 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 -51.23269474844949 2.1716883010089703)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(214,28,78)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-191.15499999999997, -252.5)",
    d: "M 198.76 295.37 C 210.44 302.66 224.23 306.87 239.01 306.87 C 240.13 306.87 241.25 306.83 242.35999999999999 306.79 L 176.64 198.13000000000002 L 139.95 198.13000000000002 L 198.76 295.37 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8704161527089619 0 0 0.8704161527089619 5.096419646420429 2.8365927941180473)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(41,52,98)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-255.87015288354775, -253.2638926403649)",
    d: "M 365.81 219.12 L 347.99 215.31 C 345.28000000000003 203.75 340.7 192.9 334.6 183.09 L 344.53000000000003 167.76 C 346.73 164.37 346.59000000000003 160.32999999999998 344.19000000000005 157.92999999999998 L 324.75000000000006 138.48999999999998 C 322.36000000000007 136.1 318.31000000000006 135.95999999999998 314.9200000000001 138.14999999999998 L 299.5900000000001 148.07999999999998 C 295.2800000000001 145.39999999999998 290.7600000000001 143.02999999999997 286.0800000000001 140.96999999999997 L 260.9700000000001 166.07999999999998 C 283.5800000000001 171.69 302.2300000000001 187.42 311.8300000000001 208.15999999999997 C 311.8100000000001 208.09999999999997 311.8000000000001 208.04999999999995 311.7800000000001 207.98999999999998 C 316.30000000000007 217.73 318.8500000000001 228.58999999999997 318.8500000000001 240.03999999999996 C 318.8500000000001 250.30999999999997 316.81000000000006 260.09999999999997 313.12000000000006 269.03999999999996 C 308.69000000000005 279.79999999999995 301.86000000000007 289.31999999999994 293.31000000000006 296.95 C 291.08000000000004 298.94 288.7200000000001 300.8 286.27000000000004 302.52 C 277.66 308.53999999999996 267.76000000000005 312.83 257.06000000000006 314.88 C 254.09000000000006 315.45 251.05000000000007 315.84 247.96000000000006 316.05 C 246.20000000000007 316.17 244.43000000000006 316.26 242.64000000000007 316.26 C 229.18000000000006 316.26 216.54000000000008 312.76 205.56000000000006 306.63 C 188.65000000000006 297.2 175.70000000000005 281.52 169.85000000000005 262.71 C 169.90000000000006 262.82 169.96000000000006 262.93 170.01000000000005 263.03999999999996 C 169.52000000000004 261.51 169.07000000000005 259.96 168.68000000000004 258.37999999999994 L 143.57000000000005 283.48999999999995 C 145.63000000000005 288.16999999999996 148.00000000000006 292.68999999999994 150.68000000000006 296.99999999999994 L 140.75000000000006 312.3299999999999 C 138.55000000000007 315.7199999999999 138.69000000000005 319.75999999999993 141.09000000000006 322.1599999999999 L 160.53000000000006 341.5999999999999 C 162.92000000000004 343.9899999999999 166.97000000000006 344.1299999999999 170.36000000000007 341.9399999999999 L 185.69000000000008 332.0099999999999 C 195.50000000000009 338.1099999999999 206.35000000000008 342.6899999999999 217.91000000000008 345.39999999999986 L 221.72000000000008 363.21999999999986 C 222.5600000000001 367.16999999999985 225.5200000000001 369.92999999999984 228.91000000000008 369.92999999999984 L 256.4000000000001 369.92999999999984 C 259.7900000000001 369.92999999999984 262.74000000000007 367.16999999999985 263.5900000000001 363.21999999999986 L 267.4000000000001 345.39999999999986 C 278.9600000000001 342.6899999999999 289.8100000000001 338.10999999999984 299.6200000000001 332.0099999999999 L 314.9500000000001 341.9399999999999 C 318.3400000000001 344.1399999999999 322.3800000000001 343.9999999999999 324.7800000000001 341.5999999999999 L 344.2200000000001 322.1599999999999 C 346.61000000000007 319.7699999999999 346.75000000000006 315.7199999999999 344.56000000000006 312.3299999999999 L 334.63 297 C 340.73 287.19 345.31 276.34 348.02 264.78 L 365.84 260.96999999999997 C 369.78999999999996 260.13 372.54999999999995 257.16999999999996 372.54999999999995 253.77999999999997 L 372.54999999999995 226.3 C 372.52 222.92 369.76 219.96 365.81 219.12 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2917db92ef5dc14e2a2250e21ee217a1.svg";
export { ForwardRef as ReactComponent };